import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';
import classNames from 'classnames';

import Icon from '../../../../helper/Icon';

export default class CollapsableItem extends Component {
  static contextTypes = {
    changeMyState: PropTypes.func,
    getHeight: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      active: props.activeIndex === props.index
    };
  }

  componentDidMount() {
    if (this.props.activeIndex === this.props.index) {
      this.slideToggle(false);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.activeIndex !== this.props.activeIndex &&
      nextProps.activeIndex === nextProps.index
    ) {
      this.slideToggle(false);
      this.state.active = true;
    } else if (
      nextProps.activeIndex !== this.props.activeIndex &&
      nextProps.activeIndex !== nextProps.index
    ) {
      this.slideToggle(true);
      this.state.active = false;
    }
  }

  slideToggle = collapse => {
    if (collapse) {
      $j(this.collapsableChildContainer)
        .stop(true, true)
        .slideUp(300);
    } else {
      $j(this.collapsableChildContainer)
        .stop(true, true)
        .slideDown(300);
    }
  };

  toggleCollapse = collapse => {
    this.props.onTitleClick && this.props.onTitleClick();
    this.context.changeMyState(collapse, this.props.index);
  };

  render() {
    const { title, children, className } = this.props;
    const wrapperClassName = classNames('CollapseableContainer', className);
    return (
      <div className={wrapperClassName}>
        <div
          role="presentation"
          className={'collapsableHeader' + (this.state.active ? ' active' : '')}
          onClick={() => this.toggleCollapse(this.state.active)}
        >
          {title}
          <div className="iconContainer">
            <Icon
              icon={this.state.active ? 'keyboard-arrow-up' : 'keyboard-arrow-down'}
              size="20px"
              fill="#000"
            />
          </div>
        </div>
        <div
          className="collapsableChildContainer hideCollapsable"
          style={{ maxHeight: this.props.contentMaxHeight, overflow: 'auto' }}
          ref={ref => (this.collapsableChildContainer = ref)}
        >
          {children}
        </div>
      </div>
    );
  }
}
